import { render, staticRenderFns } from "./FractionSelect.vue?vue&type=template&id=05480d9e&"
import script from "./FractionSelect.vue?vue&type=script&lang=js&"
export * from "./FractionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports